import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import ConnectedFormControl from '../FormControl/FormControl.js';
import { isText } from '../Util/validations.js';

const Text = (_param)=> {
    var { validations =[
        isText
    ]  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "validations"
    ]);
    return React.createElement(ConnectedFormControl, swcHelpers.extends({}, ConnectedFormControl.defaultProps, {
        validations: validations
    }, rest));
};

export { Text as default };
//# sourceMappingURL=Text.js.map
